import { Stack, Typography } from "@mui/material"
import Logo from "../../assets/erorex-Logo.png";

const ClientInfo = () => {
  return (
    <Stack
      sx={{ mb: 2, mt: 1 }}
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"end"}
      spacing={3}>
      <img src={Logo} alt="logo" height={"120"} />

      <Stack sx={{mt: "-20px"}}>
        <Typography sx={{ fontSize: "26px", fontWeight: "bold" }}>
          RZ Traders
        </Typography>
        {/* <Typography sx={{ fontSize: "16px" }}>
          Elchi Plza Uromchi Plaza Back Street,
        </Typography> */}
        {/* <Typography sx={{ fontSize: "16px" }}>
          Garden College Road Rawalpindi
        </Typography> */}
        <Typography sx={{ fontSize: "16px" }}>
          Asad Riaz : 0312-5686984
        </Typography>
        <Typography sx={{ fontSize: "16px" }}>
          M.Mushtaq: 0301-5604119
        </Typography>
      </Stack>
    </Stack>
  )
}

export default ClientInfo